export default function getDescriptiveLocation(_ref) {
  let {
    hosted,
    storeTitle,
    physicalAddress,
    level
  } = _ref;
  const hasSpecificLocation = Boolean(physicalAddress) || Boolean(level);
  let text = '';

  if (hosted) {
    text = hosted;
  } else if (storeTitle) {
    text = storeTitle;
  }

  if (text && hasSpecificLocation) {
    text = "".concat(text, ",");
  }

  if (level) {
    text = "".concat(text, " Level ").concat(level);
  }

  if (physicalAddress) {
    text = "".concat(text, " ").concat(physicalAddress);
  }

  return text.trim();
}